import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

export default function SidebarItem({ label, goToPath, icon, clearFilters, isChild, onClick }) {
  const location = useLocation();
  const isCurrentLocation = goToPath === location.pathname;

  const handleClick = () => {
    if (!isCurrentLocation) {
      clearFilters(); // Solo ejecuta clearFilters si no estamos en la misma ruta
    }
  };

  return (
    <li title={label} onClick={() => { if (!isCurrentLocation) clearFilters(); }} className={`sidebar-single-item ${isCurrentLocation ? "active" : ""}`}>

      <NavLink to={goToPath}>
        <i className={`me-1 ${icon}`}/>
        <span className={isChild ? "sidebar-child-label" : "hide-menu"}>{label}</span>
      </NavLink>
    </li>
  );
}